import React, { useState } from "react";
import { Box, Stepper, Step, StepLabel } from "@mui/material";
import { useTranslation } from "react-i18next";
import StepCaseManaQues from "./Steps/StepCaseManaQues";
import StepEducation from "./Steps/StepEducation";
import StepHousing from "./Steps/StepHousing";
import StepFinancialResources from "./Steps/StepFinancialResources";
import StepDental from "./Steps/StepDental";
import StepSpirituality from "./Steps/StepSpirituality";
import StepMentalHealthCuest from "./Steps/stepMentalHealthCuest";
import StepSummary from "./Steps/StepSummary";
import StepInsuranceTrans from "./Steps/StepInsuranceTrans";
import StepADL from "./Steps/StepADL";
import StepMentalHealthCuestTwo from "./Steps/StepMentalHealthCuestTwo";
import StepDomesticViolence from "./Steps/StepDomesticViolence";
import ProfilesPreview from "./ProfilesPreview";

// Definimos los pasos con sus traducciones
const steps = [
  "createProfiles.wizard.stepOne",  // Introducción
  "createProfiles.wizard.stepTwo",  // Diagnósticos
  "createProfiles.wizard.stepThree", // Alergias
  "createProfiles.wizard.stepFour", // Hábitos
  "createProfiles.wizard.stepFive", // Historial Médico
  "createProfiles.wizard.stepSix", // Medicaciones
  "createProfiles.wizard.stepSeven", // Planes de Tratamiento
  "createProfiles.wizard.stepEight", // Objetivos de Cuidado
  "createProfiles.wizard.stepNine", // Frecuencia de Seguimiento
  "createProfiles.wizard.stepTen", // Recomendaciones Adicionales
  "createProfiles.wizard.stepEleven", // Resumen y Confirmación
  "createProfiles.wizard.stepTwelve", // Planes de Tratamiento
  "createProfiles.wizard.stepThirteen", // Objetivos de Cuidadoión
];

export default function ProfilesCWizard({ onComplete }) {
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(0);

  // Función para avanzar
  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep((prevStep) => prevStep + 1);
    } else {
      onComplete(); // Se ejecuta cuando se finaliza el último paso
    }
  };

  // Función para retroceder
  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  // Renderizar contenido según el paso activo
  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return <StepCaseManaQues onNext={handleNext} onBack={handleBack} />;
      case 1:
        return <StepEducation onNext={handleNext} onBack={handleBack} />;
      case 2:
        return <StepHousing onNext={handleNext} onBack={handleBack} />;
      case 3:
        return <StepInsuranceTrans onNext={handleNext} onBack={handleBack} />;
      case 4:
        return <StepFinancialResources onNext={handleNext} onBack={handleBack} />;
      case 5:
        return <StepDental onNext={handleNext} onBack={handleBack} />;
      case 6:
        return <StepADL onNext={handleNext} onBack={handleBack} />;
      case 7:
        return <StepSpirituality onNext={handleNext} onBack={handleBack} />;
      case 8:
        return <StepMentalHealthCuest onNext={handleNext} onBack={handleBack} />;
      case 9:
        return <StepMentalHealthCuestTwo onNext={handleNext} onBack={handleBack} />;
      case 10:
        return <StepDomesticViolence onNext={handleNext} onBack={handleBack} />;
      case 11:
        return <StepSummary onNext={handleNext} onBack={handleBack} />;
      case 12:
        return <ProfilesPreview onNext={handleNext} onBack={handleBack} />;
      default:
        return <h3>{t("common.unknownStep")}</h3>;
    }
  };

  return (
    <Box sx={{ width: "100%", maxWidth: "1200px", margin: "auto", textAlign: "center", mt: 3 }}>
      {/* Barra de progreso */}
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel>{t(label)}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {/* Contenido dinámico del paso actual */}
      <Box sx={{ p: 3, mt: 2, backgroundColor: "#fff", borderRadius: 2, boxShadow: 3 }}>
        {renderStepContent(activeStep)}
      </Box>
    </Box>
  );
}
